import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { LanguageProvider } from "./contexts/LanguageContext";
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<LanguageProvider data-id="element-199" data-mp="21cacxxxtztcm">
      <App data-id="element-200" data-mp="2690w4u4xn529" />
    </LanguageProvider>);
}